import store from '../../store'
import Storage from '@/services/storageLib'
import { constantStrings } from '@/services/constants'
import {clearTimerForInputFieldTemporaryDisable, clearTimerForInputFieldOnSendDisableTimer} from '.././utils'
import { handleCSATSubmitEvent } from '../parser/eventParser/eventInfo'
import { getCookie } from '../cookie'
import { cookieConstant } from '../constants'

// AWS IoT Event Handlers
const IoTEvents = {
  END_CHAT: 'END_CHAT',
  FORM_SUBMISSION: 'FORM_SUBMISSION',
  FORM_CONTROLS_CLICKED: 'FORM_CONTROLS_CLICKED',
  FORM_VISIBILITY: 'FORM_VISIBILITY',
  OVERLAY_STATUS_RESUME: 'OVERLAY_STATUS_RESUME',
  OVERLAY_STATUS_RESTART: 'OVERLAY_STATUS_RESTART',
  SHOW_OVERLAY: 'SHOW_OVERLAY', // Show overlay across tabs,
  INPUT_FIELD_TEMPORARY_DISABLE: 'INPUT_FIELD_TEMPORARY_DISABLE',
  INPUT_FIELD_DISABLE_ON_SEND: 'INPUT_FIELD_DISABLE_ON_SEND',
  CLEAR_ITEMS_BEFORE_PARSING: 'CLEAR_ITEMS_BEFORE_PARSING',
  CSAT_VISIBILITY: 'CSAT_VISIBILITY',
  CSAT_SUBMIT: 'CSAT_SUBMIT',
}

const IoTEventMapperSync = {
  [IoTEvents.END_CHAT]: endChatIoTEventHandler,
  [IoTEvents.FORM_SUBMISSION]: formSubmissionIoTEventHandler,
  [IoTEvents.FORM_CONTROLS_CLICKED]: formControlsClickedIoTEventHandler,
  [IoTEvents.FORM_VISIBILITY]: formVisibilityIoTEventHandler,
  [IoTEvents.OVERLAY_STATUS_RESUME]: overlayStatusResumeIoTEventHandler,
  [IoTEvents.OVERLAY_STATUS_RESTART]: overlayStatusRestartIoTEventHandler,
  [IoTEvents.SHOW_OVERLAY]: showOverlayIoTEventHandler,
  [IoTEvents.INPUT_FIELD_TEMPORARY_DISABLE]: inputFieldTemporaryDisableIoTEventHandler,
  [IoTEvents.INPUT_FIELD_DISABLE_ON_SEND]: inputFieldDisableOnSendIoTEventHandler,
  [IoTEvents.CLEAR_ITEMS_BEFORE_PARSING]: clearItemsBeforeParsingEventHandler,
  [IoTEvents.CSAT_VISIBILITY]: csatVisibilityEventHandler,
  [IoTEvents.CSAT_SUBMIT]: csatSubmitEventHandler
}

function csatVisibilityEventHandler ({ payload }) {
  if (store.state.widgetConfig.persistentSurveyConfig?.isPersistentSurveyEnabled) {
    store.dispatch('updateCSATState', { isEnabled: payload })
  }
}
function csatSubmitEventHandler ({ payload }) {
  handleCSATSubmitEvent(payload, payload.timestamp, true)
  store.dispatch('updateCSATRateLimit')
  store.dispatch('throttleIdleChatTimeout') // Throttle chat session timeout
  store.dispatch('setIdleTimerForSurvey') // set idle timer for survey form
  store.dispatch('updateCsatSurveyTime' , payload.timestamp)
}
function endChatIoTEventHandler (data) {
  const conversationId = getCookie(cookieConstant.SESSION.CONVERSATION_ID)
  if(!conversationId) return
  csatVisibilityEventHandler({ payload: false })
  store.dispatch('endChatAcrossTabs', data.payload)
}
function formSubmissionIoTEventHandler (data) {
  store.dispatch('updateLastFormSubmission', {...data.payload, updateAcrossTabs: true})
}
function formControlsClickedIoTEventHandler (data) {
  store.dispatch('updateFormControlsClicked', data.payload)
}
function formVisibilityIoTEventHandler (data) {
  store.dispatch('updateShowFormControls', data.payload)
}
function overlayStatusResumeIoTEventHandler () {
  store.dispatch('updateOverlayStatus', false)
  Storage.setLocalStorageData('overlayStatus', false)
  store.dispatch('overlayIdleChatTimeout')
}
function overlayStatusRestartIoTEventHandler () {
  store.dispatch('updateOverlayStatus', false)
  Storage.setLocalStorageData('overlayStatus', false)
  store.dispatch('endChat', {message: constantStrings.CHAT_ENDED, publishEventToIoT: false})
  store.dispatch('clearChats')
}

function showOverlayIoTEventHandler() {
  store.dispatch('updateOverlayStatus', true)
  Storage.setLocalStorageData('overlayStatus', true)
  const timerId = store?.state?.overlayTimerId
  clearTimeout(timerId)
}

function inputFieldTemporaryDisableIoTEventHandler(data) {
  store.dispatch('updateInputFieldTempDisableStatus', data.payload)
  clearTimerForInputFieldTemporaryDisable()
}

function inputFieldDisableOnSendIoTEventHandler(data) {
  store.dispatch('updateInputFieldOnSendMessage', data.payload)
  clearTimerForInputFieldOnSendDisableTimer()
}

function clearItemsBeforeParsingEventHandler() {
  store.dispatch('clearItemsBeforeMessageParsing')
}
// AWS IoT User Messages
const IoTUserMessagesSync = (data) => {
  store.dispatch('syncUserMessageFromIoT', data)
}

// AWS IoT Bot Messages
const IoTBotMessagesSync = (data) => {
  store.dispatch('receiveAWSIoTMessage', data)
}

export {
  IoTEventMapperSync,
  IoTUserMessagesSync,
  IoTBotMessagesSync
}
